app.component("surgeonHeader", {
	templateUrl: "app/src/js/components/operationNote/surgeonHeader/surgeonHeader.html",
	controller: "surgeonHeaderController",
	bindings: {
		data: "=",
		doctors: "=",
		assistant: "@"
	},
});

app.controller("surgeonHeaderController", [
	"$scope",
	function ($scope) {
		// $scope.assistantOptions = angular.copy($ctrl.doctors);
		$scope.$watch('$ctrl.data.surgeon_user_id', function(newValue) {
			if(newValue){
				$scope.refreshAssistant();
			}
		  });

		$scope.refreshAssistant = function () {
			if(!$scope.$ctrl.assistant){
				return;
			}
			if (!($scope.$ctrl.data.surgeon_user_id == null)) {
				const list = angular.copy($scope.$ctrl.doctors);
				$scope.assistantOptions = list.filter((t) => t.value !== $scope.$ctrl.data.surgeon_user_id);
				// The assistant can't be the surgeon, and is no longer offered once they are.
				if ($scope.$ctrl.data.assistant_user_id === $scope.$ctrl.data.surgeon_user_id) {
					$scope.$ctrl.data.assistant_user_id = null;
				}
				if (!$scope.$ctrl.data.postop_care) {
					$scope.$ctrl.data.postop_care = {};
				}
				const surgeon = list.find((t) => t.value === $scope.$ctrl.data.surgeon_user_id);
				if (surgeon) {
					$scope.$ctrl.data.postop_care.clinician = surgeon.name;
				}
			}
		};
	},
]);
